const qs = require('query-string')

function getDefaultState() {
  return {
    platforms: [],
    licenseePlatforms: []
  }
}
import axios from 'axios'
import ElementUI from 'element-ui'
export default {
  namespaced: true,
  state: {
    platforms: [],
    licenseePlatforms: [],
    stores: []
  },
  getters: {
    platforms(state) {
      return state.platforms
    },
    availablePlatforms(state) {
      return state.platforms.filter((p) => p.has_main_credential || p.has_sub_credential || p.has_url)
    },
    licenseePlatforms(state) {
      return state.licenseePlatforms
    },
    stores(state) {
      return state.stores
    }
  },
  mutations: {
    setPlatforms(state, data) {
      state.platforms = data
    },
    setActivePlatforms(state, data) {
      state.licenseePlatforms = data
    },
    setStores(state, data) {
      state.stores = data
    },
    clearStores(state) {
      state.stores = []
    },
    clearState(state) {
      Object.assign(state, getDefaultState())
    }
  },
  actions: {
    async getAllPlatforms({ commit }, query) {
      await axios
        .get('/platforms' + `?${qs.stringify(query)}`)
        .then((response) => {
          commit('setPlatforms', response.data.data)
        })
        .catch(() => {})
    },
    async getActivePlatforms({ commit }, data) {
      const req = require('querystring').stringify(data)
      await axios
        .get('/platforms/active?' + req)
        .then((response) => {
          commit('setActivePlatforms', response.data.data)
        })
        .catch(() => {})
    },
    async addPlatform({ commit, dispatch }, data) {
      const title = navigator.language === 'ja' ? '完了' : 'Success'
      const message =
        navigator.language === 'ja' ? 'プラットフォーム情報を追加しました。' : 'Success to add the platform.'
      await axios
        .post('/platforms', data)
        .then((response) => {
          if (response.data.message == 'success') {
            ElementUI.MessageBox.alert(message, title, { dangerouslyUseHTMLString: false, confirmButtonText: 'OK' })
            dispatch('restaurants/getMyRestaurants', null, { root: true })
          } else {
            commit('setStores', response.data.stores)
          }
        })
        .catch(() => {})
    },
    async deletePlatforms({ dispatch }, id) {
      const title = navigator.language === 'ja' ? '成功' : 'Success'
      const message =
        navigator.language === 'ja'
          ? 'プラットフォームの連携解除に成功しました。'
          : 'Success to disconnect the platforms.'
      await axios
        .delete('/platforms', { params: { restaurant_platforms_id: id } })
        .then(() => {
          ElementUI.MessageBox.alert(message, title, { dangerouslyUseHTMLString: false, confirmButtonText: 'OK' })
          dispatch('restaurants/getMyRestaurants', null, { root: true })
        })
        .catch(() => {})
    },
    clearStores({ commit }) {
      commit('clearStores')
    },
    clearState({ commit }) {
      commit('clearState')
    }
  }
}
